'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initPusherChannel = exports.closePusherChannel = exports.pusherError = exports.CLASS_END_STATE = exports.HANDLE_PUSHER_MESSAGE = exports.INIT_PUSHER_CHANNEL = exports.CLOSE_PUSHER_CHANNEL = exports.PUSHER_ERROR = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doInitPusherChannel = doInitPusherChannel;
exports.doHandlePusherMessage = doHandlePusherMessage;
exports.watchPusherChannel = watchPusherChannel;
exports.watchPusher = watchPusher;

var _reduxSaga = require('redux-saga');

var _sagaTools = require('@classpass/saga-tools');

var _pusherJs = require('pusher-js');

var _pusherJs2 = _interopRequireDefault(_pusherJs);

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _video = require('redux/modules/video');

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

var _helpers = require('redux/saga/helpers');

var _video2 = require('constants/video');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doHandlePusherMessage),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchPusherChannel),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchPusher); /* eslint-disable no-unused-vars */


var PUSHER_ERROR = exports.PUSHER_ERROR = 'PUSHER_ERROR';
var CLOSE_PUSHER_CHANNEL = exports.CLOSE_PUSHER_CHANNEL = 'CLOSE_PUSHER_CHANNEL';
var INIT_PUSHER_CHANNEL = exports.INIT_PUSHER_CHANNEL = 'INIT_PUSHER_CHANNEL';
var HANDLE_PUSHER_MESSAGE = exports.HANDLE_PUSHER_MESSAGE = 'HANDLE_PUSHER_MESSAGE';
var CLASS_END_STATE = exports.CLASS_END_STATE = 'ENDED';

var pusherError = exports.pusherError = _helpers.errorActionCreator.bind(null, PUSHER_ERROR);
var closePusherChannel = exports.closePusherChannel = function closePusherChannel() {
  return { type: CLOSE_PUSHER_CHANNEL };
};
var initPusherChannel = exports.initPusherChannel = function initPusherChannel(channelName) {
  return { type: INIT_PUSHER_CHANNEL, channelName: channelName };
};

function doInitPusherChannel(channelName) {
  return (0, _reduxSaga.eventChannel)(function (emitter) {
    var config = (0, _universalConfig2.default)();
    var socket = new _pusherJs2.default(config.pusher.appKey, {
      cluster: config.pusher.cluster,
      encrypted: true
    });
    var channel = socket.subscribe(channelName);
    channel.bind('leaderboard', function (data) {
      return emitter({ type: 'HANDLE_PUSHER_MESSAGE', data: data });
    });
    return function () {
      socket.disconnect();
    };
  });
}

function doHandlePusherMessage(client, _ref) {
  var data = _ref.data;

  var user, _data$entries, participants, classState, myIndex, payload;

  return _regenerator2.default.wrap(function doHandlePusherMessage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 3:
          user = _context.sent;
          _data$entries = data.entries, participants = _data$entries === undefined ? [] : _data$entries, classState = data.class_state;
          myIndex = participants.findIndex(function (p) {
            return p.user_id === user.id;
          });
          payload = {
            classState: classState,
            leaderboard: {
              participants: participants,
              myIndex: myIndex
            },
            score: myIndex >= 0 ? participants[myIndex].points : 0
          };


          if (data.target_zone) {
            payload.targetZone = data.target_zone;
          }

          if (!(classState === CLASS_END_STATE)) {
            _context.next = 11;
            break;
          }

          _context.next = 11;
          return (0, _effects.put)((0, _video.videoCompleted)());

        case 11:
          _context.next = 13;
          return (0, _effects.put)((0, _video.updateDevice)(payload));

        case 13:
          _context.next = 19;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context['catch'](0);
          _context.next = 19;
          return (0, _effects.put)(pusherError(_context.t0));

        case 19:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 15]]);
}

function watchPusherChannel(client, _ref2) {
  var channelName = _ref2.channelName;

  var channel, _ref3, action, cancel;

  return _regenerator2.default.wrap(function watchPusherChannel$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(doInitPusherChannel, channelName);

        case 2:
          channel = _context2.sent;

        case 3:
          if (!true) {
            _context2.next = 14;
            break;
          }

          _context2.next = 6;
          return (0, _effects.race)({
            action: (0, _effects.take)(channel),
            cancel: (0, _effects.take)(CLOSE_PUSHER_CHANNEL)
          });

        case 6:
          _ref3 = _context2.sent;
          action = _ref3.action;
          cancel = _ref3.cancel;
          _context2.next = 11;
          return (0, _effects.put)(action);

        case 11:

          if (cancel || action.data.class_state === _video2.VIDEO_CLASS_STATE.ENDED) {
            channel.close();
          }
          _context2.next = 3;
          break;

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function watchPusher(client) {
  return _regenerator2.default.wrap(function watchPusher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, INIT_PUSHER_CHANNEL, watchPusherChannel, client);

        case 2:
          _context3.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, HANDLE_PUSHER_MESSAGE, doHandlePusherMessage, client);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}